import { createPortal } from 'react-dom';
import { DatePicker, Button } from 'antd';
import dayjs from 'dayjs';

import { useIsSuperAdmin ,useIsAdmin, useMobileStore, } from '../../store';

function DatePickerModal({ 
  showCalendar, 
  onClose, 
  onDateSelect, 
  disableDate,
  disableTime,
  timeZone 
}) {
  if (!showCalendar) return null;
  const isMobile = useMobileStore((state) => state.isMobile);
  // Convert unix timestamp back to input format for defaultValue
  const defaultValue = dayjs().subtract(2, 'minutes').format('YYYY-MM-DDTHH:mm:ss');
  
  // For min/max constraints (replaces disabledDate/disabledTime)
  const minValue = dayjs().subtract(7, 'days').format('YYYY-MM-DDTHH:mm:ss');
  const maxValue = dayjs().format('YYYY-MM-DDTHH:mm:ss');

return createPortal(
  <>
    {/* Backdrop - clicking closes the modal */}
    <div 
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 999,
        backgroundColor: 'rgba(0, 0, 0, 0.5)'
      }}
      onClick={onClose}
    />

    {!isMobile ? (
      /* Desktop - AntD DatePicker */
      <div 
        id="datepicker-container"
        style={{
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          zIndex: 1000,
          backgroundColor: 'white',
          padding: '24px',
          borderRadius: '8px',
          border: '1px solid #d9d9d9',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
          minWidth: '400px',
          minHeight: '450px'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <DatePicker
          style={{ width: "100%" }}
          showTime={{ format: 'HH:mm:ss' }}
          onChange={(value, timeString) => {
            if (!value) return;
            onDateSelect(value);
          }}
          format={'MM/DD/YYYY HH:mm:ss'}
          disabledDate={disableDate}
          disabledTime={disableTime}
          open
          getPopupContainer={() => document.getElementById('datepicker-container')}
          dropdownClassName="datepicker-dropdown"
          onOk={onClose}
          renderExtraFooter={() => (
            <div style={{ textAlign: "right" }}>
              <Button size="small" onClick={onClose}>
                Cancel
              </Button>
            </div>
          )}
        />
      </div>

    ) : (
      /* Mobile - native datetime input wrapped in a modal box */
      <div
        style={{
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          zIndex: 1000,
          backgroundColor: 'white',
          padding: '24px',
          borderRadius: '8px',
          border: '1px solid #d9d9d9',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
          width: '90%',         // responsive on small screens
          maxWidth: '360px',
        }}
        onClick={(e) => e.stopPropagation()} // prevent backdrop close
      >
        <label style={{ display: 'block', marginBottom: '8px', fontWeight: 500 }}>
          Select Date & Time
        </label>

        <input
          type="datetime-local"
          defaultValue={defaultValue}
          min={minValue}
          max={maxValue}
          step="1"
          onChange={(e) => {
          if (!e.target.value) return;
            const dayjsValue = dayjs(e.target.value); // convert to dayjs
          if (!dayjsValue.isValid()) return;        // safety check
            onDateSelect(dayjsValue);                 // same type as AntD version ✅
          }} // don't forget to wire this back up
          style={{
            width: '100%',
            padding: '8px',
            borderRadius: '6px',
            border: '1px solid #d9d9d9',
            fontSize: '16px', // prevents iOS auto-zoom
            boxSizing: 'border-box',
          }}
        />

        {/* Action buttons */}
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px', marginTop: '16px' }}>
          <Button size="small" onClick={onClose}>Cancel</Button>
          <Button size="small" type="primary" onClick={onClose}>OK</Button>
        </div>
      </div>
    )}
  </>,
  document.body
);
}

export default DatePickerModal